import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.25 13.75V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V13.75",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			className: "stroke"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.41699 9.16663L11.0003 13.75L15.5837 9.16663",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			className: "stroke"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 13.75V2.75",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			className: "stroke"
		})
	]
});
export default SvgDocumentsIcon;
